import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { useEffect, useState } from "react";

import { ExtendedFieldsOptionsContainer } from "./ProfileFieldTab";
import { keys } from "./ProfileFieldsAndSacraments";
import SacramentFieldOption from "./SacramentFieldOption";
import {
  H4,
  IconButton,
  Line,
  Loading,
  LoadingContainer,
} from "./SacramentsList";
import { useRefreshBoardData } from "./useRefreshBoardData";

SacramentFields.propTypes = {
  boardID: number,
  orderBy: number,
  setSelectedSacrament: func,
  sacrament: shape({
    title: string,
    icon: string,
    networkFieldId: string,
    defaultFieldTypeInstanceMapping: string,
    columnType: number,
    isCurrentlyOnBoard: bool,
    subfields: arrayOf(
      shape({
        title: string,
        icon: string,
        networkFieldID: number,
        defaultFieldTypeInstanceMapping: string,
        columnType: number,
        isCurrentlyOnBoard: bool,
      })
    ),
  }),
  setShowPopover: func,
  setActiveKey: func,
};

export default function SacramentFields({
  sacrament,
  setSelectedSacrament,
  boardID,
  orderBy,
  setShowPopover,
  setActiveKey,
}) {
  const [isSavingSelection, setIsSavingSelection] = useState(false);
  const goBack = () => {
    setActiveKey(keys.SACRAMENTS);
  };

  const { refreshBoardData, isLoading } = useRefreshBoardData({
    onSuccess: () => setShowPopover(false),
  });

  useEffect(() => {
    return () => setSelectedSacrament(undefined);
  }, [setSelectedSacrament]);

  const subfields = sacrament?.subfields.sort((a, b) => {
    if (a.isCurrentlyOnBoard) return 1;
    return -1;
  });

  if (!sacrament) return null;

  if (isLoading || isSavingSelection) {
    return (
      <LoadingContainer>
        <Loading color="blue" />
      </LoadingContainer>
    );
  }

  return (
    <>
      <ExtendedFieldsOptionsContainer onClick={(e) => e.stopPropagation()}>
        <H4>
          <IconButton onClick={goBack}>
            <i className={`fas fa-chevron-left`} />
          </IconButton>
          {sacrament?.title}
        </H4>
        <Line />
        {/* DATE IS THE TOP LEVEL INFO IN SACRAMENT FOR REASONS I CAN'T REMEMBER */}
        {/* DATE IS AT THE TOP IF IT ISN'T ALREADY ON THE BOARD. OTHERWISE, IT IS ON THE BOTTOM */}
        {!sacrament?.isCurrentlyOnBoard && (
          <SacramentFieldOption
            key={sacrament.networkFieldID}
            boardID={boardID}
            field={{
              title: "Date",
              icon: "calendar fas",
              networkFieldID: sacrament.networkFieldID,
              defaultFieldTypeInstanceMapping:
                sacrament.defaultFieldTypeInstanceMapping,
              columnType: sacrament.columnType,
              isCurrentlyOnBoard: sacrament.isCurrentlyOnBoard,
            }}
            orderBy={orderBy}
            sacramentName={sacrament.title}
            setShowPopover={setShowPopover}
            refreshBoardData={refreshBoardData}
            isSavingSelection={isSavingSelection}
            setIsSavingSelection={setIsSavingSelection}
          />
        )}

        {subfields?.map((field, idx) => (
          <SacramentFieldOption
            key={field.networkFieldID}
            boardID={boardID}
            field={field}
            orderBy={orderBy}
            setShowPopover={setShowPopover}
            refreshBoardData={refreshBoardData}
            isSavingSelection={isSavingSelection}
            setIsSavingSelection={setIsSavingSelection}
          />
        ))}

        {sacrament?.isCurrentlyOnBoard && (
          <SacramentFieldOption
            key={sacrament.networkFieldID}
            boardID={boardID}
            field={{
              title: "Date",
              icon: "calendar fas",
              networkFieldID: sacrament.networkFieldID,
              defaultFieldTypeInstanceMapping:
                sacrament.defaultFieldTypeInstanceMapping,
              columnType: sacrament.columnType,
              isCurrentlyOnBoard: sacrament.isCurrentlyOnBoard,
            }}
            orderBy={orderBy}
            sacramentName={sacrament.title}
            setShowPopover={setShowPopover}
            refreshBoardData={refreshBoardData}
          />
        )}
      </ExtendedFieldsOptionsContainer>
    </>
  );
}
